import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import btn_icon_401543 from './images/btn_icon_401543.png';
import Header from './Header';
import MenuTop from './MenuTop';
import ButtonEnterheader from './ButtonEnterheader';
import MintButtom from './MintButtom';
import Logo from './Logo';
import ThemnemosyneTitle from './ThemnemosyneTitle';
import HeadelineH2 from './HeadelineH2';
import TheKeys from './TheKeys';
import ThePortals from './ThePortals';
import CallToAction from './CallToAction';
import Roadmap2 from './Roadmap2';
import RoadMap from './RoadMap';
import TokenomicsTitle from './TokenomicsTitle';
import Tokenomics from './Tokenomics';
import StartUsingProtsy from './StartUsingProtsy';
import Component3 from './Component3';
import PortsyARCall from './PortsyARCall';
import DownloadNow from './DownloadNow';
import OurTeam from './OurTeam';
import TeamMember from './TeamMember';
import SocialLinks from './SocialLinks';
import btn_icon_625800 from './images/btn_icon_625800.png';

// UI framework component imports
import Button from 'muicss/lib/react/button';

export default class HomeScreen extends Component {

  static contextType = ScreenContext;


  constructor(props) {
    super(props);
    
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  onClick_elIconButton = async () => {
  
  }
  
  
  onClick_elMint_Button = async () => {
  
  }
  
  
  
  onClick_elFab = async () => {
    alert("This is a demo");
  
  }
  
  
  render() {
    let layoutFlowStyle = {};
    let baseStyle = {};
    if (this.context.transitionId && this.context.transitionId.length > 0 && this.context.atTopOfScreenStack && this.context.transitionForward) {
      baseStyle.animation = '0.25s ease-in-out '+this.context.transitionId;
    }
    if ( !this.context.atTopOfScreenStack) {
      layoutFlowStyle.height = '100vh';
      layoutFlowStyle.overflow = 'hidden';
    }
    
    // eslint-disable-next-line
    const dataSheet_team = this.context.dataSheets['team'];
    
    const style_elBackgroundShape = {
      background: 'rgba(0, 0, 0, 1.000)',
     };
    
    const style_elIconButton = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_401543+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '82.239%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elIconButton_outer = {
      display: 'none',
     };
    const style_elMint_Button = {
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elTokenomicsTBD_outer = {
      display: 'none',
     };
    
    // Source items and any special components used for list/grid element 'Team pics'.
    let items_teamPics = [];
    let listComps_teamPics = {};
    items_teamPics = items_teamPics.concat(this.context.appActions.getDataSheet('team').items);
    this._elTeamPics_items = [];
    
    const style_elTeamPics = {
      height: 'auto',  // This element is in scroll flow
     };
    const style_elSpacerCopy2_outer = {
      display: 'none',
     };
    
    const style_elFab = {
      display: 'block',
      textTransform: 'none',
      color: '#fff',
      textAlign: 'center',
      backgroundColor: '#222835',
      cursor: 'pointer',
      pointerEvents: 'auto',
      display: 'none',
     };
    
    return (
      <div className="AppScreen HomeScreen" style={baseStyle}>
        <div className="background">
          <div className="elBackgroundShape" style={style_elBackgroundShape} />
        </div>
        
        <div className="layoutFlow" style={layoutFlowStyle}>
          <div className="flowRow flowRow_HomeScreen_elIconButton_401543">
          <div className="elIconButton" style={style_elIconButton_outer}>
            <button className="actionFont" style={style_elIconButton} onClick={this.onClick_elIconButton}  />
          </div>
          
          </div>
          <div className="hasNestedComps elHeaderBkg">
            <div>
              <Header {...this.props} ref={(el)=> this._elHeaderBkg = el} />
            </div>
          </div>
          
          <div className="flowRow flowRow_HomeScreen_elMenu_Top_576490">
          <div className="hasNestedComps elMenu_Top">
            <div>
              <MenuTop ref={(el)=> this._elMenu_Top = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elEnterButtonHeader">
            <div>
              <ButtonEnterheader ref={(el)=> this._elEnterButtonHeader = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elMint_Button">
            <div style={style_elMint_Button} onClick={this.onClick_elMint_Button} >
              <MintButtom ref={(el)=> this._elMint_Button = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elLogo">
            <div>
              <Logo ref={(el)=> this._elLogo = el} />
            </div>
          </div>
          
          </div>
          <div className="hasNestedComps elHeaderIntroduction">
            <div>
              <ThemnemosyneTitle {...this.props} ref={(el)=> this._elHeaderIntroduction = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elIntroduction">
            <div>
              <HeadelineH2 ref={(el)=> this._elIntroduction = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elTheKeysThePortals">
            <div>
              <div className="col0">
                <TheKeys />
              </div>
              <div className="col1">
                <ThePortals />
              </div>
            </div>
          </div>
          
          <div className="elSpacer">
            <div />
          </div>
          
          <div className="hasNestedComps elCallToAction">
            <div>
              <CallToAction ref={(el)=> this._elCallToAction = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elRoadMapHeader">
            <div>
              <Roadmap2 {...this.props} ref={(el)=> this._elRoadMapHeader = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elRoadMap">
            <div>
              <RoadMap {...this.props} ref={(el)=> this._elRoadMap = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elThemnemosyneTitle">
            <div>
              <TokenomicsTitle ref={(el)=> this._elThemnemosyneTitle = el} />
            </div>
          </div>
          
          <div className="flowRow flowRow_HomeScreen_elTokenomicsTBD_140708">
          <div className="hasNestedComps elTokenomicsTBD" style={style_elTokenomicsTBD_outer}>
            <div>
              <Tokenomics ref={(el)=> this._elTokenomicsTBD = el} />
            </div>
          </div>
          
          </div>
          <div className="hasNestedComps elStartCreatingYoruOwnPortals">
            <div>
              <StartUsingProtsy ref={(el)=> this._elStartCreatingYoruOwnPortals = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elComponent">
            <div>
              <Component3 ref={(el)=> this._elComponent = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elPortsyARCall">
            <div>
              <PortsyARCall ref={(el)=> this._elPortsyARCall = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elDownloadNow">
            <div>
              <DownloadNow ref={(el)=> this._elDownloadNow = el} />
            </div>
          </div>
          
          <div className="elSpacer2">
            <div />
          </div>
          
          <div className="hasNestedComps elOurTeam">
            <div>
              <OurTeam ref={(el)=> this._elOurTeam = el} />
            </div>
          </div>
          
          <div className="hasNestedComps elTeamPics">
            <div style={style_elTeamPics}>
              {items_teamPics.map((row, index) => {
                let itemComp = (row._componentId)
                    ? listComps_teamPics[row._componentId]
                    : <TeamMember dataSheetId={'team'} dataSheetRow={row} {...{ 'name': row['name'], 'description': row['description'], 'image': row['image'], }} ref={(el) => {if (el) this._elTeamPics_items.push(el)}} />;
                return (<div key={row.key || index}>
                    {itemComp}
                  </div>);
              })}
              <div className="marker" ref={(el)=> this._elTeamPics_endMarker = el} />
            </div>
          </div>
          
          <div className="flowRow flowRow_HomeScreen_elSpacerCopy2_302004">
          <div className="elSpacerCopy2" style={style_elSpacerCopy2_outer}>
            <div />
          </div>
          
          </div>
          <div className="hasNestedComps elSocial">
            <div>
              <SocialLinks {...this.props} ref={(el)=> this._elSocial = el} />
            </div>
          </div>
        </div>
        
        <div className="screenFgContainer">
          <div className="foreground">
            <Button className="actionFont elFab" style={style_elFab}  variant="fab" onClick={this.onClick_elFab} >
              <img src={btn_icon_625800} alt="" style={{width: '50.000%', marginTop: '25.000%'}} />
            </Button>
          </div>
        </div>
      </div>
    )
  }
  
}
